import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ChunkErrorBoundary } from "./components/ChunkErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";

// Register service worker for better cache management
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  navigator.serviceWorker.register('/sw.js')
    .then(() => console.log('[SW] Service Worker registered'))
    .catch((err) => console.error('[SW] Registration failed:', err));
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <ChunkErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ChunkErrorBoundary>
  </ErrorBoundary>
);
